module.exports = __webpack_public_path__ + "img/bee__8.4b12e71c.svg";